<template>
  <div>
    <HotTable
      ref="hotTableComponent"
      :settings="hotSettings"
      :data="receivables">
    </HotTable>

    <Modal v-model="modalPopup" width="85%" title="Detail Summary" :mask-closable="false">
        <div>
          <Spin size="large" v-show="isLoadingDataPopup"></Spin>
          <Table border ref="selection" :columns="columnsDataTable" :data="detailMarking" v-show="!isLoadingDataPopup"></Table>
        </div>
    </Modal>
    <Modal v-model="modalPopupDetail" width="85%" :title="detailSummaryTitle" :mask-closable="false">
        <div>
          <Spin size="large" v-show="isLoadingDataPopup"></Spin>
          <Tabs :animated="false">
            <TabPane v-for="(header) in receivableHeader"
                            :key="header"
                            :label="String(header)">
                <Table border ref="selection"
                  :row-class-name="rowClassName"
                  :columns="columnsDataTable"
                  :data="receivableDetail[header]" v-show="!isLoadingDataPopup">
                </Table>
            </TabPane>
          </Tabs>
        </div>
    </Modal>
  </div>

</template>

<script>
  import {HTTP} from '@/components/http-lib'
  import Handsontable from "handsontable";
  import { HotTable } from '@handsontable/vue';
  import { registerAllModules } from "handsontable/registry";

  registerAllModules();

  import "handsontable/dist/handsontable.full.min.css";

  import moment from 'moment'

  const numeral = require('numeral');

  function showDateFormatted(stringToFormat){
    let dateToFormat = moment(stringToFormat, 'YYYY-MM-DD').toDate();
    return moment(dateToFormat).format("DD MMM YYYY")
  }

  export default {
    props: {
        hotHeaders : Array,
        hotColumns : Array,
        receivableLists : Array,
        customizeRows : Array,
        isType: '',
        invoiceSummaryDate : ''
    },
    data () {
      console.log("hot : ", this.receivableLists);

      return {
        receivables: this.receivableLists,
        modalPopup: false,
        modalPopupDetail: false,
        receivableHeader: [],
        receivableDetail: {},
        detailSummaryTitle: null,
        isLoadingDataPopup: false,
        columnsDataTable: [
          {
              title: 'Tanggal',
              key: 'invoiceDate'
          },
          {
              title: 'No. Container',
              key: 'containerNumber'
          },
          {
              title: 'Keterangan',
              key: 'description'
          },
          {
              title: 'No. Rekening',
              key: 'no_rek'
          },
          {
              title: 'Debit',
              key: 'debitAmount'
          },
          {
              title: 'Kredit',
              key: 'creditAmount'
          },
          {
              title: 'Saldo',
              key: 'balance'
          }
        ],
        detailMarking: []
      }
    },
    components: {
      HotTable
    },
    methods: {
      getHotSettings() {
        let parentThis = this;
        let showDateFormattedVar = function(dateParam) {
          return showDateFormatted(dateParam);
        }

        function geturnID(val){
          if (val == 'ID')
            return 2

          return false
        }

        this.hotSettings = {
          licenseKey: "non-commercial-and-evaluation",
          height: 600,
          width: "100%",
          stretchH: "all",
          dropdownMenu: true,
          filters: true,
          columnSorting: true,
          autoColumnSize: true,
          autoRowSize: true,
          colHeaders: true,
          hiddenColumns: {
            columns: geturnID('ID'),
            indicators: true
          },
          copyPaste: false,
          colHeaders: this.hotHeaders,
          colWidths(col) {
            let width = col == 2 ? 300 : 150;
            return width;
          },
          columns: this.hotColumns,
          cells: function (row, col, prop) {
            var cellProperties = {};

            // summary marking only
            if (parentThis.customizeRows) {
              parentThis.customizeRows.forEach(element => {
                if (element === row) {
                  cellProperties.renderer = function (instance, td) {
                    Handsontable.renderers.TextRenderer.apply(this, arguments);
                    td.style.backgroundColor = 'darkgrey';
                    td.style.color = 'white';
                    td.style.fontWeight = 'bold';
                  };
                }
              });
            }

            return cellProperties;
          },
          afterOnCellMouseDown: function(event, coords, td) {
            if (parentThis.isType == 'isSummaryAllMarking') {
              let rowdata = parentThis.$refs.hotTableComponent.hotInstance.getSourceDataAtRow(coords.row);
              console.log(rowdata)

              let markingId = rowdata['markingheaderid']
              let markingheadercode = rowdata['markingheadercode']

              console.log(rowdata)

              parentThis.receivableHeader = []
              parentThis.receivableDetail = {}


              parentThis.modalPopupDetail = true
              parentThis.isLoadingDataPopup = true

              parentThis.detailSummaryTitle = "Detail Summary Marking " + markingheadercode

              HTTP.post('receivable/getSummary', {
                  markingHeaderId: markingId,
                  summaryDate: parentThis.invoiceSummaryDate,
              }).then(response => {
                  let receivables = []
                  let countBalance = 0;

                  _.forEach(response.data, function(value, index) {
                      let invoicefee = value.invoice != null ? value.invoice.invoicefee : 0;
                      let debitAmount = value.debitAmount;
                      let creditAmount = value.creditAmount;
                      let totalvolume = value.invoice != null ? value.invoice.totalvolume : 0;
                      let description = value.description
                      let containerNumber = value.invoice != null ? value.invoice.packaging_list.container_loading.containernumber : '-'
                      let invoiceDate = value.invoice != null ? showDateFormattedVar(value.invoice.invoicedate) : '-'
                      let transactionDate = value.transactionDate != null ? showDateFormattedVar(value.transactionDate) : '-'

                      let isSettled = parentThis.isSettled(value.invoice_due)

                      if(value.invoice != null)
                      {
                          description += " (vol = " + numeral(totalvolume).format('0.000');

                          if(invoicefee != debitAmount){
                              description += ", inv = " + numeral(invoicefee).format('0,0')
                          }

                          description += ")"
                      }

                      let subBalance = (debitAmount - creditAmount)
                      countBalance = (countBalance + subBalance)

                      let arrayDescriptionContainer = '';

                      if(value.payment != null){
                          if(value.payment.payment_allocate != null){
                              arrayDescriptionContainer = value.payment.payment_allocate
                          }
                      }

                      _.forEach(arrayDescriptionContainer, function(paymentAllocate) {
                          if(paymentAllocate.invoice_due != null){
                              description += ' - '+paymentAllocate.invoice_due.receivable.description
                          } else {
                              description += ' <font style="color:red">- NOT_FOUND </font>'

                              var errorMessage = 'Transaksi tgl ' + showDateFormattedVar(value.transactionDate) + ' ada Invoice yang berubah';

                              parentThis.$Notice.warning({
                                  title: "Perhatian",
                                  desc: errorMessage,
                                  duration: 0
                              });

                          }
                      })

                      let receivable = {
                          invoicefee : numeral(invoicefee).format('0,0'),
                          markingheadercode : value.marking_header.markingheadercode,
                          description : description,
                          isSettled : isSettled,
                          debitAmount : numeral(debitAmount).format('0,0'),
                          creditAmount : numeral(creditAmount).format('0,0'),
                          balance : numeral(countBalance).format('0,0'),
                          invoiceDate: invoiceDate,
                          transactionDate: transactionDate,
                          containerNumber: containerNumber
                      }

                      receivables.push(receivable);
                  });

                  const groupedHeader = [];
                  const groupedDetail = {};

                  receivables.forEach((item) => {
                    const year = new Date(item.transactionDate).getFullYear();
                    if (!groupedDetail[year]) {
                      groupedDetail[year] = [];
                      groupedHeader.push(year)
                    }
                    groupedDetail[year].push(item);
                  });

                  parentThis.receivableHeader = groupedHeader
                  parentThis.receivableDetail = groupedDetail

                  parentThis.isLoadingDataPopup = false
              }).catch(e => {
                  this.$Notice.error({
                      title: "Error",
                      desc: e,
                      duration: 5
                  });
              });
            }
          },
        };
      },
      rowClassName (row, index) {
          if (row.isSettled) {
              return 'demo-table-warning-row';
          }

          return '';
      },
      isSettled : function (invoice){
          if(invoice != null){
              if(invoice.settledDate == null){
                      return true;
              }
          }

          return false;
      }
    },
    components: {
      HotTable
    },
    beforeMount() {
      this.getHotSettings();
    },
}
</script>

<style>
  .handsontable .warning-bg {
    background-color: yellow;
  }
  .handsontable .default-bg {
    background-color: white;
  }
  .btn-custom {
    background: none;
    border: none;
    color: gray;
    width: 100%;
    text-align: left;
  }
  .ivu-table .demo-table-info-row td{
        color: #19be6b;
    }
  .ivu-table .demo-table-warning-row td{
      color: #c74444;
  }
</style>



// WEBPACK FOOTER //
// cReceivableHotList.vue?200c5230